import config from '../config';
import { getToken } from './auth';

const api = async (path, options = {}) => {
  let token;
  try {
    token = await getToken();
  } catch (err) {
    // No valid session (expired refresh token, cleared storage, etc.).
    // Signal the app to return to the login screen rather than surfacing
    // "Not signed in" inline on whatever page the user is currently on.
    window.dispatchEvent(new Event('auth:expired'));
    throw err;
  }
  const res = await fetch(`${config.apiUrl}${path}`, {
    ...options,
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json', ...options.headers },
  });
  if (res.status === 401) {
    window.dispatchEvent(new Event('auth:expired'));
    throw new Error('Your session has expired. Please sign in again.');
  }
  if (!res.ok) throw new Error(`API ${res.status}: ${await res.text()}`);
  return res.json();
};

export const getProfiles = () => api('/profiles');
export const createProfile = (data) => api('/profiles', { method: 'POST', body: JSON.stringify(data) });
export const deleteProfile = (id) => api(`/profiles/${id}`, { method: 'DELETE' });
export const getCuratedNews = async (dashboardId, startDate, endDate) => {
  // First call triggers curation
  const initial = await api(`/news/${dashboardId}?startDate=${startDate}&endDate=${endDate}`);
  if (initial.status === 'ready') return initial;

  // Poll for results
  for (let i = 0; i < 30; i++) {
    await new Promise((r) => setTimeout(r, 3000));
    const res = await api(`/news/${dashboardId}?startDate=${startDate}&endDate=${endDate}&poll=true`);
    if (res.status === 'ready') return res;
  }
  throw new Error('Curation timed out. Try a shorter date range.');
};
export const refreshNews = () => api('/refresh', { method: 'POST' });
export const getSnapshots = (cursor) => api(`/snapshots?limit=20${cursor ? `&cursor=${cursor}` : ''}`);
export const getSnapshot = (id) => api(`/snapshots/${encodeURIComponent(id)}`);
export const deleteSnapshot = (id) => api(`/snapshots/${encodeURIComponent(id)}`, { method: 'DELETE' });
export const getTemplates = () => api('/templates');
export const getTemplate = (id) => api(`/templates/${encodeURIComponent(id)}`);
export const updateTemplate = (id, data) => api(`/templates/${encodeURIComponent(id)}`, { method: 'PUT', body: JSON.stringify(data) });
export const sendSnapshotEmail = (id, email, templateId) => api(`/snapshots/${encodeURIComponent(id)}/send-email`, { method: 'POST', body: JSON.stringify({ email, templateId }) });
